export function webviewReducer(state: boolean = false) {
  return state;
}
